<template>
  <section 
  id="as-section-about-agent"
  class="as-section as-section--has-padding as-section--about-agent"
  data-section="about-agent">
    <div class="container">
      
      <div class="as-section__intro" :class="hasVideoUrl ? '' : 'text-lg-center'">
        <h2 class="as-section__title">About the Agent</h2>
      </div>
      
      <div class="row" :class="hasVideoUrl ? '' : 'justify-content-lg-center'">
        
        <div class="col-lg-7 as-section__content-col" :class="hasVideoUrl ? 'pr-lg-5' : 'd-lg-flex flex-lg-column align-items-lg-center'">
          
          <div class="user-object d-flex align-items-start">
            <img
              class="user-object__avatar rounded-circle mb-1 mb-lg-0"
              v-if="agent && agent.avatar"
              :src="storageDir + `/avatars/${agent.avatar}`"
              :alt="
                `User avatar for ${agent.full_name} ${agent.last_name}`
              "
            />
            <img
              v-else
              :src="storageDir + '/avatars/default.jpg'"
              class="user-object__avatar rounded-circle mb-1 mb-lg-0"
              alt="Default user avatar"
            />
            <div class="user-object__content-wrapper">
              <h3 class="user-object__heading">
                {{agent.first_name}} {{agent.last_name}}
              </h3>
              <h4 class="user-object__sub-heading">
                {{agent.company}}
              </h4>
              <!-- <p class="user-object__meta user-object__meta--border-bottom mb-1">{{ property.company }}</p> -->
              <p class="user-object__meta">
                <span class="d-inline-block mr-2">Contact: </span>
                <a :href="'mailto:' + agent.email">
                  <i class="far fa-envelope blue d-inline-block mr-1"></i>
                  Email
                </a>
                <a
                  class="d-inline-block ml-1 user-object__phone-link"
                  :href="'tel:' + agent.phone">
                    <i class="far fa-phone blue d-inline-block mr-1"></i>
                  {{agent.phone}}
                </a>
              </p>

            </div>

          </div><!-- End user object -->

        </div><!-- End col -->

        <template v-if="hasBio">
          <div class="as-section__agent-bio col-lg-6 as-section__content-col d-lg-flex flex-lg-column">
            <div v-html="agent.agent_page.bio"></div>
          </div>
        </template>

        
        <template v-if="hasVideoUrl">
          <div class="col-lg-5 as-section__video-col">

            <h4 class="as-section__sub-title text-center py-2">A message from the Agent</h4>

            <div class="video-wrapper">
                <iframe width="100%" height="100%" :src="`https://www.youtube.com/embed/${agent.agent_page.video_url}?theme=dark&autohide=1&modestbranding=1&showinfo=0&rel=0`" frameborder="0" allowfullscreen></iframe>
            </div>
            
          </div><!-- End col -->
        </template>
        
      </div>
      
    </div>
  </section>
</template>

<script>
import WaypointMixin from '@vue/mixins/waypoint-mixin';
export default {
  mixins: [
    WaypointMixin
  ],
  props: {
    storageDir: {},
    agent: {
      type: Object,
      required: true
    },
  },

  computed: {
    hasVideoUrl(){
      return this.agent && this.agent.agent_page && this.agent.agent_page.video_url ? true : false;
    },
    hasBio(){
      return this.agent && this.agent.agent_page && this.agent.agent_page.bio ? true : false;
    }
  },

  mounted() {
    this.$addObserver(this.$el, this.onWaypointEnter, this.intersectionOptions);
  }
  
}
</script>